import React, { useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup, Table } from "react-bootstrap";
import MyNavbarInner from "../component/navbarinner";
import MyNavbar from "../component/navbar";

import Countdown, { zeroPad } from "react-countdown";
import { Link } from "react-router-dom";
import { Ellipsis } from "react-awesome-spinners";
import Web3 from "web3";

import { parseUnits } from "viem";
import { useWalletClient, useDisconnect } from "wagmi";
import { useWallet } from "./walletconnect/walletContext";
import { walletClientToSigner } from "../helper/ethersconnect";
import config from "../config/config";
import {
  buyToken,
  approveToken,
  getBalanceInfo,
  claimToken,
  claimBidProcess,
  getPhasesList,
  getVouchorBalance,
  getInvestDetails,
  getUserVoucherDetails,
  redeemVoucher,
} from "./buyContract";
import { tokenValue } from "../helper/custommath";
import { savePurchase, getLatestCount, saveReward, getParentReferral, saveClaimBid, getUserInfo, getReferralList } from "../ApiAction/api";
import { toastAlert } from "../helper/toastAlert";
import {
  numberFloatOnly,
  formatNumber,
  shortText,
  numberOnly,
} from "../helper/custommath";
import { useChainId } from "wagmi";
import { getKycInfo } from "../ApiAction/api";
import isEmpty from "is-empty";

import BuyHistory from "./buyHistory";

export default function Buytoken_page() {
  const { connectors, address, isConnected, connectWallet, disconnectWallet } = useWallet();
  console.log('isConnected :', isConnected);
  console.log('Buytoken_pageaddress :', address);
  const [rate, setrate] = useState(0);
  const [receive, setreceive] = useState("");
  const [need, setneed] = useState(0);
  const [connval, setconnval] = useState(null);
  const [showallowance, setshowallowance] = useState(false);
  const [loader, setloader] = useState(false);
  const [claimload, setclaimload] = useState(false);
  const [redemLoader, setRedemLoader] = useState(false)
  const [isload, setisload] = useState(false);
  const [loadhistory, setloadhistory] = useState(false);
  const [user, setUser] = useState({});
  const [referralId, setReferralId] = useState(user?.referralId || "");
  const [balanceallowance, setbalanceallowance] = useState({
    balance: 0,
    allowance: 0,
  });
  const [sendreceive, setsendreceive] = useState({ pay: "", receive: "" });
  const [showInfo, setshowInfo] = useState({
    totalreward: "",
    totalinvestmanet: "",
    totalusers: "",
    availableReward: "",
    referralBal: 0,
    totalWin: 0,
  });
  const [tntyhour, settntyhour] = useState(0);
  const [referralBal, setreferralBal] = useState(0);
  const [totalAvailable, settotalAvailable] = useState(0);
  const [isKyc, setisKyc] = useState("");
  const [walletAddr, setwalletAddr] = useState("");
  const [displayrate, setdisplayrate] = useState("");
  const [bonus, setbonus] = useState(0);
  const [benifit, setbenifit] = useState(0);
  const [totalSold, settotalSold] = useState(0);
  const [userBonus, setuserBonus] = useState(0);
  const [userInvestment, setuserInvestment] = useState(0);
  const [userId, setuserId] = useState("");
  const [claimableamount, setclaimableamount] = useState(0);
  const [referralAddr, setreferralAddr] = useState("");
  const [isUsed, setisUsed] = useState("");
  const [phaseslist, setphasesList] = useState([]);
  const [voucherlist, setvoucherList] = useState([]);
  console.log('voucherlist :', voucherlist);
  const [activePhases, setActivePhases] = useState({});
  const [parentWallet, setParentWallet] = useState("");
  const [referror, setreferror] = useState("");
  const [withdrawPer, setWithdrawPer] = useState("");
  const [bucket, setBucket] = useState("");
  const [bucketValue, setBucketValue] = useState(0);
  const [bucketValues, setBucketValues] = useState({
    2: "",
    3: "",
    4: "",
    5: ""
  });
  const [progress, setProgress] = useState(0);

  const [withdrawDetails, setWithdrawDetails] = useState({
    withdrawAmt: 0,
    bidAmt: 0,
    EquivalentAmt: 0,
  });
  const [copied, setCopied] = useState(false);
  const [filter, setFilter] = useState({ skip: 1, limit: 10 });

  useEffect(() => {
    if (user?.referralId) {
      setReferralId(user.referralId);
    }
  }, [user]);


  const [investData, setInvestData] = useState({
    myInvest: 0,
    myReward: 0,
    totalBid: 0,
    totalClaimed: 0
  });
  const [totalEntered, setTotalEntered] = useState(0);

  var chainId = config.chainId;
  const { data: walletClient } = useWalletClient({ chainId });
  const buyTokenSectionRef = useRef(null);
  useEffect(() => {
    getBalance();
    getVouchBalance();
    getUserInvestData();
    DigitalVoucherList();
  }, [connval]);

  useEffect(() => {
    try {
      var { transport } = walletClientToSigner(walletClient);
      setconnval(transport);
    } catch (err) { }
  }, [address, walletClient]);

  async function getData() {
    try {
      let { data, status, encryptuserId, ref, wallet, alreadywallet } =
        await getKycInfo(address);
      var kyvstatus = "";
      if (data?.status == "pending") {
        kyvstatus = "Processing";
      }
      if (data?.status == "approved") {
        kyvstatus = "Verified";
      } else if (data?.status == "rejected") {
        kyvstatus = "Rejected";
      }
      setisKyc(kyvstatus);
      setwalletAddr(wallet);
      setwalletAddr(wallet);
      setuserId(encryptuserId);
      setreferralAddr(ref);
      setisUsed(alreadywallet);
    } catch (err) { }
    return;
  }

  async function getBalance() {
    setisload(true);
    let {
      balanceOf,
      allowance,
      tokenprice,
      totalreward,
      totalinvestmanet,
      totalusers,
      availableReward,
      rewardPerc,
      claimable,
    } = await getBalanceInfo(address, connval);
    setshowInfo({ totalreward, totalinvestmanet, totalusers, availableReward });
    // setbalanceallowance({ balance: balanceOf, allowance: allowance });
    setrate(tokenprice);
    getData();
    setisload(false);
    var cal = tokenprice / 1000000;
    cal = 1 / cal;
    setdisplayrate(formatNumber(cal, 5));
    setbenifit(rewardPerc);

    let {
      count,
      referralwintoken,
      bonuswintoken,
      totalWintoken,
      totalBonustoken,
      totalinvestment,
    } = await getLatestCount();
    settntyhour(count);
    setreferralBal(formatNumber(referralwintoken, 4));
    let total = bonuswintoken + referralwintoken;

    settotalAvailable(formatNumber(total, 4));
    //var sold = totalWintoken + totalreward;
    var sold = totalreward;
    settotalSold(formatNumber(sold, 4));
    setuserBonus(formatNumber(bonuswintoken, 4));
    setuserInvestment(formatNumber(totalinvestment, 4));

    setclaimableamount(claimable);
  }

  async function getVouchBalance() {
    let address1 = address
    if (!address1) address1 = "0x0000000000000000000000000000000000000000";
    let { balanceOf, allowance } = await getVouchorBalance(address);
    setbalanceallowance({ balance: balanceOf, allowance: allowance });
  }

  async function getUserInvestData() {
    let address1 = address
    if (!address1) address1 = "0x0000000000000000000000000000000000000000";
    let { myInvest, myReward, totalBid, totalClaimed } = await getInvestDetails(address);
    setInvestData({ myInvest, myReward, totalBid, totalClaimed });
  }

  async function handleConnect(connector) {
    disconnectWallet();

    try {
      var network = config.chainId;

      let check = isMobile();
      var isType = connector && connector.id ? connector.id : "";

      if (check && !window.ethereum && isType == "metaMaskSDK") {
        connectMetamaskMobile();
        return;
      } else {
        var web3 = null;
        if (isType == "injected") {
          web3 = new Web3(window.BinanceChain);
        } else if (isType !== "walletConnect") {
          web3 = new Web3(window.ethereum);
        } else {
          var rpcUrl = config.rpc[network];
          web3 = new Web3(rpcUrl);
        }
        var currnetwork = await web3.eth.net.getId();

        if (
          parseInt(currnetwork) !== parseInt(network) &&
          isType !== "walletConnect"
        ) {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: Web3.utils.toHex(network) }],
          });
          currnetwork = network;
        }
        await connectWallet(connector);
        window.$("#exampleModal").modal("hide");
      }
    } catch (err) {
      var error = err && err.message ? err.message.toString() : err.toString();
      var pos = error.search("Provider not set or invalid");
      var pos1 = error.search("User rejected");
      if (pos >= 0) {
        toastAlert("error", "Please login into metamask", "errormetamask");
      } else if (pos1 >= 0) {
        toastAlert("error", "Confirmation is rejected", "errormetamask");
      } else {
        toastAlert("error", "Please try again later", "errormetamask");
      }
    }
  }

  const connectMetamaskMobile = () => {
    const currentUrl = window.location.href;

    // Split the URL to get the dapp URL
    const urlParts = currentUrl.split("//");
    if (urlParts.length > 1) {
      const dappUrl = urlParts[1].split("/")[0];
      const metamaskAppDeepLink = "https://metamask.app.link/dapp/" + dappUrl;
      window.open(metamaskAppDeepLink, "_self");
    } else {
      console.error("Invalid URL format");
    }
  };

  function isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  const getPhases = async () => {
    const phases = await getPhasesList();
    setphasesList(phases);
  };

  const DigitalVoucherList = async () => {
    const Voucher = await getUserVoucherDetails(address);
    setvoucherList(Voucher);
  };

  async function buy() {
    try {
      if (!need || need == 0 || need == "0") {
        toastAlert("error", "Please enter amount", "bytkn");
        return;
      }
      if (!referralId || referralId == "") {
        setloader(false);
        toastAlert("error", "Please enter the referral Id", "bytkn");
        return;
      }
      if (parseFloat(need) < 1) {
        toastAlert("error", "The minimum deposit amount is 1 USDT", "bytkn");
        return;
      }
      if (
        parseFloat(sendreceive?.pay) > parseFloat(balanceallowance?.balance)
      ) {
        toastAlert("error", "Insufficient USDT balance", "bytkn");
        return;
      }
      var uId = userId;
      var ref = referralAddr;
      var wallet = walletAddr;
      var isDuplicate = isUsed;
      if (!uId) {
        var { encryptuserId, ref, wallet, alreadywallet } = await getKycInfo();
        uId = encryptuserId;
        isDuplicate = alreadywallet;
      }

      if (isDuplicate == "true") {
        toastAlert("error", "Kindly use a different wallet", "bytkn");
        return;
      }

      if (uId == "") {
        toastAlert("error", "Please try again later", "bytkn");
        return;
      }

      if (wallet && wallet.toLowerCase() != address.toLowerCase()) {
        toastAlert("error", `Please login into this wallet ${wallet}`, "bytkn");
        return;
      }
      if (referror) {
        toastAlert("error", referror, "bytkn");
        return;
      } else if (
        parentWallet.toLowerCase() == wallet.toLowerCase() ||
        parentWallet.toLowerCase() == address.toLowerCase()
      ) {
        toastAlert(
          "error",
          `Invalid referral code. Please enter a valid one`,
          "bytkn"
        );
        return;
      } else if (!isEmpty(referralId) && isEmpty(parentWallet)) {
        toastAlert(
          "error",
          `The referral parent does not have a wallet address. Please use a different referral.`,
          "bytkn"
        );
        return;
      }

      if (isEmpty(referralId) && isEmpty(parentWallet)) {
        toastAlert("error", `Invalid referral Id. Please enter a valid one`, "bytkn");
      }
      console.log(address, connval, need, uId, ref, "8*******************");
      setloader(true);
      const walletToUse = parentWallet ? parentWallet.toLowerCase() : "";
      var {
        txId,
        status,
        message,
        tokenAmount,
        usdtAmount,
        refBonusAmt,
        buyer,
        referrer,
      } = await buyToken(connval, address, walletToUse, need, activePhases?.id);

      setloader(true);
      console.log(txId, status, "txId, status,");
      if (status) {
        toastAlert(
          "success",
          "Your transaction is successfully completed",
          "bytkn"
        );
        await savePurchase({
          address,
          txId,
          amount: usdtAmount,
          receive: tokenAmount,
          refBonusAmt: refBonusAmt,
          referrer: referrer,
          refCode: referralId,
        });

        getVouchBalance();
        setloadhistory(true);
        setsendreceive({ pay: "", receive: "" });
        getPhases();
        getUserInvestData();
        getVouchBalance();
        // setReferralId();
      } else {
        toastAlert("error", message, "bytkn");
      }
      setloader(false);
    } catch (err) {
      setloader(false);
    }
  }

  const handlechange = async (e) => {
    let value = e.target.value;
    let isNum = numberOnly(value);
    if (isNum) {
      setneed(value);
      const receiveAmt = parseFloat(value / activePhases?.pricePerWin);
      setreceive(receiveAmt);
      setshowallowance(false);

      if (value > balanceallowance.allowance) {
        setshowallowance(true);
      }
      let Info = { pay: value, receive: receiveAmt };
      setsendreceive(Info);
    }
  };

  const handlechange1 = async (e) => {
    let value = e.target.value;

    if (value === "") {
      setWithdrawPer("");
      setWithdrawDetails({
        withdrawAmt: 0,
        bidAmt: 0,
        EquivalentAmt: 0,
      });
      setBucketValue(null);
      return;
    }

    let isNum = numberOnly(value);
    if (isNum && Number(value) > 0 && Number(value) <= 10) {
      setWithdrawPer(value);

      let withdrawTotal = parseFloat(investData?.myReward * (value / 100));
      let bidAmt = parseFloat(investData?.myReward - withdrawTotal);
      let EquAmt = parseFloat(bidAmt * activePhases?.pricePerWin);

      setWithdrawDetails({
        withdrawAmt: withdrawTotal,
        bidAmt: bidAmt,
        EquivalentAmt: EquAmt,
      });

      if (bucket) {
        const selectedPhase = phaseslist.find(
          (p) => String(p.id) === String(bucket)
        );
        if (selectedPhase) {
          setBucketValue(parseFloat(bidAmt * selectedPhase?.pricePerWin));
        }
      }
    } else if (Number(value) > 10) {
      setWithdrawPer(10);
      let withdrawTotal = parseFloat(investData?.myReward * (10 / 100));
      let bidAmt = parseFloat(investData?.myReward - withdrawTotal);
      let EquAmt = parseFloat(bidAmt * activePhases?.pricePerWin);

      setWithdrawDetails({
        withdrawAmt: withdrawTotal,
        bidAmt: bidAmt,
        EquivalentAmt: EquAmt,
      });

      if (bucket) {
        const selectedPhase = phaseslist.find(
          (p) => String(p.id) === String(bucket)
        );
        if (selectedPhase) {
          setBucketValue(parseFloat(bidAmt * selectedPhase?.pricePerWin));
        }
      }
    }
  };

  const handleBucketChange = (e) => {
    const selectedValue = e.target.value;
    setBucket(selectedValue);

    const selectedPhase = phaseslist.find(
      (p) => String(p.id) === String(selectedValue)
    );

    if (selectedPhase) {
      console.log("Selected Phase Details:", selectedPhase);

      const bidAmt = withdrawDetails?.bidAmt || 0;
      setBucketValue(parseFloat(bidAmt * selectedPhase?.pricePerWin));
    } else {
      console.warn("No phase found for bucket:", selectedValue);
      setBucketValue(null);
    }
  };

  async function approve() {
    setloader(true);
    try {
      if (!need || need == 0 || need == "0") {
        setloader(false);
        toastAlert("error", "Please enter amount", "bytkn");
        return;
      }
      if (!referralId || referralId == "") {
        setloader(false);
        toastAlert("error", "Please enter the referral Id", "bytkn");
        return;
      }

      if (parseFloat(need) < 1) {
        setloader(false);
        toastAlert("error", "The minimum deposit amount is 1 USDT", "bytkn");
        return;
      }
      if (
        parseFloat(sendreceive?.pay) > parseFloat(balanceallowance?.balance)
      ) {
        setloader(false);
        toastAlert("error", "Insufficient USDT balance", "bytkn");
        return;
      }
      var wallet = walletAddr;
      if (wallet && wallet.toLowerCase() != address.toLowerCase()) {
        toastAlert("error", `Please login into this wallet ${wallet}`, "bytkn");
        return;
      }
      if (referror) {
        toastAlert("error", referror, "bytkn");
        return;
      } else if (
        parentWallet.toLowerCase() == wallet.toLowerCase() ||
        parentWallet.toLowerCase() == address.toLowerCase()
      ) {
        toastAlert(
          "error",
          `Invalid referral code. Please enter a valid one`,
          "bytkn"
        );
        return;
      } else if (!isEmpty(referralId) && isEmpty(parentWallet)) {
        toastAlert(
          "error",
          `The referral parent does not have a wallet address. Please use a different referral.`,
          "bytkn"
        );
        return;
      } else if (isEmpty(referralId) && isEmpty(parentWallet)) {
        toastAlert(
          "error",
          `Invalid referral Id. Please enter a valid one`,
          "bytkn"
        );
      }
      var { approvalAmt, isAllowed, error } = await approveToken(
        address,
        connval
      );
      if (isAllowed) {
        if (need > approvalAmt) {
          toastAlert("error", "Insufficient approval amount", "register");
        } else {
          toastAlert("success", "Successfully approved", "register");
          setshowallowance(false);
        }
      } else {
        toastAlert("error", error, "register");
      }
      setloader(false);
    } catch (err) {
      setloader(false);
    }
  }

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="timer_panel">
        <div className="timer_head">
          <div className="timer_time">{zeroPad(days)}</div>
          <div className="timer_label">Days</div>
        </div>
        <div className="timer_head">
          <div className="timer_time">{zeroPad(hours)}</div>
          <div className="timer_label">Hours</div>
        </div>

        <div className="timer_head">
          <div className="timer_time">{zeroPad(minutes)}</div>
          <div className="timer_label">Minutes</div>
        </div>

        <div className="timer_head">
          <div className="timer_time">{zeroPad(seconds)}</div>
          <div className="timer_label">Seconds</div>
        </div>
      </div>
    );
  };
  const staticTargetDate = new Date("2025-06-02T00:00:00");
  staticTargetDate.setDate(staticTargetDate.getDate() + 13);

  async function claimReward() {
    try {
      if (claimload) {
        toastAlert("error", "Please wait , transaction is processing", "bytkn");
        return;
      }

      var wallet = walletAddr;
      if (!wallet) {
        var resp = await getKycInfo();
        wallet = resp?.wallet;
      }
      console.log(wallet, address, "+++++++++++++++++123");
      if (wallet && address && wallet.toLowerCase() != address.toLowerCase()) {
        toastAlert("error", `Please login into this wallet ${wallet}`, "bytkn");
        return;
      }

      setclaimload(true);
      var { txId, status, message, reward } = await claimToken(
        address,
        connval
      );

      setclaimload(true);

      if (status) {
        toastAlert(
          "success",
          "Your transaction is successfully completed",
          "bytkn"
        );
        saveReward({
          address,
          txId,
          receive: reward,
        });
        getBalance();
        setloadhistory(true);
        setsendreceive({ pay: "", receive: "" });
        setclaimableamount(0);
      } else {
        toastAlert("error", message, "bytkn");
      }
      setclaimload(false);
    } catch (err) {
      setclaimload(false);
    }
  }

  const handleScrollToBuy = () => {
    setTimeout(() => {
      if (buyTokenSectionRef.current) {
        buyTokenSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  useEffect(() => {
    getPhases();
  }, []);

  useEffect(() => {
    if (phaseslist && phaseslist.length > 0) {
      const activePhase = phaseslist.find((p) => p.active && !p.completed);
      if (activePhase) setActivePhases(activePhase);
    }
  }, [phaseslist]);

  console.log(phaseslist, activePhases, voucherlist, "getPhases");
  const getParentWallet = async () => {
    if (referralId) {
      const { status, wallet, message } = await getParentReferral({
        referralId,
      });
      if (status == true) {
        setParentWallet(wallet);
        setreferror("");
      } else if (message) {
        setreferror(message);
      } else {
        setParentWallet("");
        setreferror("");
      }
    } else {
      setreferror("");
    }
  };

  useEffect(() => {
    getParentWallet();
  }, [referralId]);

  async function ClaimReward() {
    try {
      if (claimload) {
        toastAlert("error", "Please wait, transaction is processing", "bytkn");
        return;
      }

      if (!withdrawPer || withdrawPer == 0) {
        toastAlert("error", "Please enter withdraw percentage", "bytkn");
        return;
      }

      if (totalEntered < withdrawDetails?.bidAmt) {
        toastAlert(
          "error",
          `Please allocate the full amount. Remaining: ${formatNumber(withdrawDetails?.bidAmt - totalEntered, 6)
          }`,
          "bytkn"
        );
        return;
      }

      if (totalEntered > withdrawDetails?.bidAmt) {
        toastAlert(
          "error",
          "Allocated amount cannot be greater than Bid Amount!",
          "bytkn"
        );
        return;
      }


      if (withdrawPer == "") {
        toastAlert("error", "Please enter withdraw percentage", "bytkn");
        return;
      }

      var wallet = walletAddr;
      if (!wallet) {
        var resp = await getKycInfo();
        wallet = resp?.wallet;
      }
      if (wallet && address && wallet.toLowerCase() != address.toLowerCase()) {
        toastAlert("error", `Please login into this wallet ${wallet}`, "bytkn");
        return;
      }

      setclaimload(true);

      const bucketIds = [];
      const bucketAmounts = [];

      for (let key in bucketValues) {
        const val = parseFloat(bucketValues[key]) || 0;
        if (val > 0) {
          bucketIds.push(Number(key));
          console.log(val, "val");
          const uintAmount = val * 10 ** 18;
          console.log(uintAmount, "uintAmount");
          bucketAmounts.push(uintAmount);
        }
      }

      var { txId, status, message } = await claimBidProcess(
        address,
        connval,
        withdrawPer,
        bucketIds,
        bucketAmounts
      );

      if (status) {
        toastAlert("success", "Your transaction was successful!", "bytkn");
        saveClaimBid({
          address,
          txId,
          bidAmt: withdrawDetails?.bidAmt,
          withdrawAmt: withdrawDetails?.withdrawAmt,
          EquiAmt: withdrawDetails?.EquivalentAmt,
          // bucketPosValue: bucketValue,
          // bucketId: bucket,
        });
        window.$("#claimModal").modal("hide");
        setWithdrawPer("");
        setBucket("");
        setBucketValue("");
        setWithdrawDetails({
          withdrawAmt: 0,
          bidAmt: 0,
          EquivalentAmt: 0,
        });
        getUserInvestData();
        getVouchBalance();
        DigitalVoucherList();
        setWithdrawDetails({ withdrawAmt: 0, bidAmt: 0, EquivalentAmt: 0 });
        setBucketValues({ 2: "", 3: "", 4: "", 5: "" });
        setTotalEntered(0);
        setProgress(0);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toastAlert("error", message, "bytkn");
        setWithdrawPer("");
        setBucket("");
        setBucketValue("");
        setWithdrawDetails({ withdrawAmt: 0, bidAmt: 0, EquivalentAmt: 0 });
        setBucketValues({ 2: "", 3: "", 4: "", 5: "" });
        setTotalEntered(0);
        setProgress(0);
        setWithdrawDetails({
          withdrawAmt: 0,
          bidAmt: 0,
          EquivalentAmt: 0,
        });
      }
      setclaimload(false);


      setclaimload(false);
    } catch (error) {
      setclaimload(false);
      resetFormStates();
    }
  }
  const handleCopy = () => {
    navigator.clipboard.writeText(
      `${config.frontUrl}?ref=${user?.encryptuserId}`
    );
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  const getDataUser = async () => {

    try {
      let { userData, totalrecords, result, status, isKyc } =
        await getReferralList(filter);
      if (status === true) {
        setUser(userData);
        setReferralId(userData.referralId)
      }
    } catch (err) {
      console.error("Error fetching referral data", err);
    }
    setloader(false);
  };

  useEffect(() => {
    getDataUser()
    localStorage.removeItem("referralCode")
  }, [filter])




  const resetFormStates = () => {
    setWithdrawPer("");
    setBucket("");
    setBucketValue("");
    setWithdrawDetails({ withdrawAmt: 0, bidAmt: 0, EquivalentAmt: 0 });
    setBucketValues({ 2: "", 3: "", 4: "", 5: "" });
    setTotalEntered(0);
    setProgress(0);
  };


  const handleBucketInput = (e, bucket) => {
    let input = e.target.value;

    if (withdrawPer == "" || !withdrawPer || withdrawPer == 0) {
      toastAlert("error", "Please enter withdraw percentage", "bytkn");
      return;
    }

    if (input === "") {
      setBucketValues({ ...bucketValues, [bucket]: "" });

      const total = Object.values({ ...bucketValues, [bucket]: 0 }).reduce(
        (sum, val) => sum + parseFloat(val || 0),
        0
      );
      setTotalEntered(total);
      setProgress(Math.min((total / (withdrawDetails?.bidAmt || 1)) * 100, 100));
      return;
    }

    if (!/^\d*\.?\d*$/.test(input)) return;

    const value = parseFloat(input);
    const bidAmount = parseFloat(withdrawDetails?.bidAmt || 0);
    const currentBucketValue = parseFloat(bucketValues[bucket] || 0);
    const newTotal = totalEntered - currentBucketValue + value;

    if (newTotal > bidAmount) {
      toastAlert("error", "You cannot enter more than Bid Amount!", "bytkn");
      return;
    }

    const updatedBuckets = { ...bucketValues, [bucket]: input };
    setBucketValues(updatedBuckets);

    setTotalEntered(newTotal);
    setProgress(Math.min((newTotal / bidAmount) * 100, 100));
  };

  const handleRedeemVoucher = async (voucherId) => {
    try {
      setRedemLoader(true)
      var wallet = walletAddr;
      if (!wallet) {
        var resp = await getKycInfo();
        wallet = resp?.wallet;
      }
      if (wallet && address && wallet.toLowerCase() != address.toLowerCase()) {
        toastAlert("error", `Please login into this wallet ${wallet}`, "bytkn");
        return;
      }
      var { txId, status, message } = await redeemVoucher(address, connval, voucherId)
      if (status) {
        toastAlert("success", "Your redeem was successful!");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toastAlert("error", message, "bytkn");
      }
    } catch (err) {
      console.error("Error in handleRedeemVoucher ", err);
    } finally {
      setRedemLoader(false)
    }
  }




  console.log(showInfo, "showInfo");
  console.log(user, "user")

  return (
    <>
      <MyNavbarInner />
      <section>
        <Container>
          <Row className="justify-content-center">
            <Col xl="10" md="12">
              <div className="d-flex align-items-end justify-content-end mb-4">
                <Link to="/dashboard" className="">
                  <img
                    src={require("../assets/images/back_icon.png")}
                    alt=""
                    className="img-fluid"
                  />{" "}
                  Back
                </Link>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl="10" md="12">
              <div className="reg_form Buytoken_page">
                {/* <p>Presale</p>
                <div className="Buytoken_page_head">
                  <div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Total Participants</p>
                        <h6 className="mb-0">{showInfo?.totalusers}</h6>
                      </div>
                    </div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Total Investment (USDT)</p>
                        <h6 className="mb-0">{showInfo?.totalinvestmanet} </h6>
                      </div>
                    </div>

                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Total Sold Token</p>
                        <h6 className="mb-0">{totalSold} </h6>
                      </div>
                    </div>

                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Joined Last 24 hrs</p>
                        <h6 className="mb-0">{tntyhour}</h6>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>My Investment (USDT)</p>
                        <h6 className="mb-0">{userInvestment} </h6>
                      </div>
                    </div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Referral WIN Tokens</p>
                        <h6 className="mb-0">{referralBal} </h6>
                      </div>
                    </div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>Bonus WIN Tokens</p>
                        <h6 className="mb-0">{userBonus} </h6>
                      </div>
                    </div>
                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>My tokens(WIN)</p>
                        <h6 className="mb-0">
                          {!isNaN(totalAvailable) ? totalAvailable : 0}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}
                {isload && (
                  <div className="text-center">
                    <Ellipsis className="loading mx-auto" color="white" />
                  </div>
                )}
                <div className="mt-4 d-flex flex-wrap gap-3">
                  {/* Wallet Address */}
                  <div className="flex-fill">
                    <Form.Label className="input_join" htmlFor="walletAddress">
                      Wallet Address
                    </Form.Label>
                    <InputGroup className="input_group_box">
                      <Form.Control
                        id="walletAddress"
                        placeholder={localStorage.getItem("rememberedEmail")}
                        aria-label="Wallet Address"
                        readOnly
                      />
                    </InputGroup>
                  </div>

                  {/* Referral Link */}
                  <div className="flex-fill">
                    <Form.Label className="input_join" htmlFor="referralLink">
                      Your Referral Link
                    </Form.Label>
                    <InputGroup className="input_group_box">
                      <Form.Control
                        id="referralLink"
                        placeholder={`${config.frontUrl}?ref=${user?.encryptuserId}`}
                        aria-label="Referral Link"
                        readOnly
                      />
                      <InputGroup.Text
                        id="copyReferral"
                        onClick={handleCopy}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={require("../assets/images/copy_icon.png")}
                          alt="Copy"
                          className="img-fluid ms-2"
                          width={20}
                          height={20}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    {copied && (
                      <p style={{ color: "pink", marginTop: "5px" }}>Copied!</p>
                    )}
                  </div>
                </div>

                {/* <div className="timeing_sec">

                  <div className="bonus">{benifit}% Bonus</div>
                  <p className="join_head mb-0">Presale Discount Ends in</p>
                  <Countdown date={staticTargetDate} renderer={renderer} />
                </div> */}
                {voucherlist.length > 0 && (
                  <div className="phase_section my-5">
                    <h2>Digital Voucher</h2>
                    <div className="w-100 py-3 overflow-x-auto">
                      <div className="d-flex align-items-center gap-3">
                        {voucherlist &&
                          voucherlist?.length > 0 &&
                          voucherlist.map((value, i) => {
                            return (
                              <div className="voucher_single">
                                <div className="d-grid grid-cols-3 gap-3 mb-4 voucher_single_head">
                                  <div className="d-flex flex-column gap-2 text-center">
                                    <label>Serial Number</label>
                                    <p className="mb-0">{value?.serial}</p>
                                  </div>
                                  <div className="d-flex flex-column gap-2 text-center">
                                    <label>Token Amount</label>
                                    <p className="mb-0">
                                      {value?.tokenAmount} WIN
                                    </p>
                                  </div>
                                  <div className="d-flex flex-column gap-2 text-center">
                                    <label>Phase Name</label>
                                    <p className="mb-0">
                                      Phase {value?.bucketId}
                                    </p>
                                  </div>
                                </div>
                                <div className="d-grid grid-cols-2 gap-3 voucher_single_head">
                                  <div className="d-flex flex-column gap-2 text-center">
                                    <label>Wallet Address</label>
                                    <p className="mb-0">
                                      {shortText(value?.buyer)}
                                    </p>
                                  </div>
                                  <div className="d-flex flex-column gap-2 text-center">
                                    <label>Date/Time of Purchase</label>
                                    <p className="mb-0">{value?.createdAt}</p>
                                  </div>
                                </div>
                                {value.voucherRedeemEnabled &&
                                  <div className="text-center mt-3">
                                    <button className="primary_btn"
                                      disabled={!value.voucherRedeemEnabled || redemLoader}
                                      onClick={() => handleRedeemVoucher(value.id)}
                                    >
                                      {redemLoader ? <i className="fas fa-spinner fa-spin"></i> : "Redeem"}
                                    </button>
                                    {/* <button className="primary_btn ms-2">Share</button> */}
                                  </div>}
                              </div>
                            );
                          })}
                        {/* // <div className="voucher_single">
                      //   <div className="d-grid grid-cols-3 gap-3 mb-4 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Serial Number</label>
                      //       <p className="mb-0">WIN00001</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Token Amount</label>
                      //       <p className="mb-0">150 WIN</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Phase Name</label>
                      //       <p className="mb-0">Phase 1</p>
                      //     </div>
                      //   </div>
                      //   <div className="d-grid grid-cols-2 gap-3 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Wallet Address</label>
                      //       <p className="mb-0">0xE6.....4995</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Date/Time of Purchase</label>
                      //       <p className="mb-0">09-10-2025 12:40 PM</p>
                      //     </div>
                      //   </div>
                      //   <div className="text-center mt-3">
                      //     <button className="primary_btn" disabled>
                      //       Redeem
                      //     </button>
                      //     <button className="primary_btn ms-2">Share</button>
                      //   </div>
                      // </div>

                      // <div className="voucher_single">
                      //   <div className="d-grid grid-cols-3 gap-3 mb-4 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Serial Number</label>
                      //       <p className="mb-0">WIN00001</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Token Amount</label>
                      //       <p className="mb-0">150 WIN</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Phase Name</label>
                      //       <p className="mb-0">Phase 1</p>
                      //     </div>
                      //   </div>
                      //   <div className="d-grid grid-cols-2 gap-3 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Wallet Address</label>
                      //       <p className="mb-0">0xE6.....4995</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Date/Time of Purchase</label>
                      //       <p className="mb-0">09-10-2025 12:40 PM</p>
                      //     </div>
                      //   </div>
                      //   <div className="text-center mt-3">
                      //     <button className="primary_btn" disabled>
                      //       Redeem
                      //     </button>
                      //     <button className="primary_btn ms-2">Share</button>
                      //   </div>
                      // </div>

                      // <div className="voucher_single">
                      //   <div className="d-grid grid-cols-3 gap-3 mb-4 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Serial Number</label>
                      //       <p className="mb-0">WIN00001</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Token Amount</label>
                      //       <p className="mb-0">150 WIN</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Phase Name</label>
                      //       <p className="mb-0">Phase 1</p>
                      //     </div>
                      //   </div>
                      //   <div className="d-grid grid-cols-2 gap-3 voucher_single_head">
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Wallet Address</label>
                      //       <p className="mb-0">0xE6.....4995</p>
                      //     </div>
                      //     <div className="d-flex flex-column gap-2 text-center">
                      //       <label>Date/Time of Purchase</label>
                      //       <p className="mb-0">09-10-2025 12:40 PM</p>
                      //     </div>
                      //   </div>
                      //   <div className="text-center mt-3">
                      //     <button className="primary_btn" disabled>
                      //       Redeem
                      //     </button>
                      //     <button className="primary_btn ms-2">Share</button>
                      //   </div>
                      // </div> */}
                      </div>
                    </div>
                  </div>
                )}

                {/* <div className="phase_section my-5">
                  <h2>Token Phase List</h2>
                  <div className="accordion" id="accordionExample2">
                    <div className="accordion-item custom_acc_item phase_accordion">
                      <h2 className="accordion-header" id="consultQuestOne">
                        <button
                          className="accordion-button acc_btn collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultCollapseOne"
                          aria-expanded="true"
                          aria-controls="consultCollapseOne"
                        >
                          <span>Phase 1</span>
                          <span>200,000 WIN</span>
                        </button>
                      </h2>
                      <div
                        id="consultCollapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="consultQuestOne"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body acc_body">
                          <div className="text-center mb-4">
                            <svg
                              id="fi_18295118"
                              enable-background="new 0 0 100 100"
                              viewBox="0 0 100 100"
                              xmlns="http://www.w3.org/2000/svg"
                              width={50}
                            >
                              <path
                                d="m94.1149368 59.6092033c-1.9655228-3.057457-3.9310303-6.0057449-5.896553-9.0632019-.4367828-.6551819-.4367828-1.0919571 0-1.7471352 1.9655228-2.9482727 3.8218384-5.8965454 5.7873611-8.8448334 2.2930984-3.4942474 1.0919495-6.8793106-2.8390808-8.2988548-3.2758636-1.2011566-6.5517197-2.5114975-9.8275833-3.7126369-.6551743-.2183876-.9827652-.6551781-.9827652-1.4195442-.1091919-3.6034508-.3275833-7.2069016-.5459747-10.7011499-.2183838-3.8218393-3.1666641-6.0057468-6.879303-5.022995-3.4942474.8735666-6.9884949 1.8563185-10.3735619 2.8390865-.7643661.2183876-1.2011566 0-1.7471313-.5459766-2.1839104-2.8390865-4.4770203-5.5689716-6.6609268-8.2988567-2.4022942-3.0574741-6.1149483-3.0574741-8.6264305 0-2.1839066 2.7298846-4.4770164 5.4597697-6.5517235 8.1896534-.5459747.7643642-1.0919533.8735666-1.965519.655179-3.3850632-.9827518-6.7701111-1.8563185-9.1724052-2.5114975-4.695406-1.0919533-7.5344753.7643652-7.7528801 4.695406-.2183876 3.6034498-.4367752 7.2069025-.5459766 10.9195375 0 .7643642-.327589 1.0919552-.9827518 1.4195442-3.3850641 1.3103409-6.7701111 2.6206818-10.1551743 3.9310398-3.4942493 1.4195442-4.5862036 4.8045921-2.5114975 7.9712677 1.9655204 3.0574722 3.9310408 6.0057449 5.8965445 9.0632019.4367752.6551819.4367752 1.0919571 0 1.8563385-2.0747061 3.057457-4.040226 6.1149483-6.0057464 9.2816048-1.8563185 2.9482918-.655179 6.4425201 2.6206822 7.7528839 3.3850641 1.3103561 6.8793135 2.6206818 10.2643604 3.9310379.7643642.2184067.9827518.6551819.9827518 1.4195251.1092014 3.4942703.5459766 6.8792953.5459766 10.3735657 0 3.4942627 3.0574741 6.6609192 7.3160877 5.350563 3.3850632-1.0919495 6.7701092-1.8563309 10.1551762-2.8390884.6551781-.218399 1.0919533-.1091995 1.5287285.5459824 2.2931099 2.8390808 4.4770164 5.5689697 6.7701111 8.4080582 2.5114937 3.057457 6.1149483 3.057457 8.5172424 0 2.2931099-2.8390884 4.4770164-5.5689774 6.7701111-8.4080582.4367752-.5459824.7643623-.7643814 1.5287285-.5459824 3.4942513.9827576 6.9884987 1.8563385 10.4827614 2.8390884 3.6034546.9827499 6.6609192-1.2011566 6.7701111-4.9137878.2183914-3.6034393.4367828-7.2069092.5459824-10.9195404 0-.8735504.4367828-1.2011566 1.0919495-1.4195251 3.2758636-1.2011566 6.6609192-2.5114822 9.9367828-3.8218384 3.4942932-1.7471381 4.5862503-5.2414008 2.5115356-8.4080611zm-26.0976944-17.9080352-21.8390732 21.839077c-.5459785.5459747-1.3103447.9827499-2.074707 1.0919495-.2183876 0-.5459785.1092072-.7643661.1092072-.9827499 0-2.0747032-.4367752-2.8390846-1.2011566l-8.9540195-8.9540367c-1.5287285-1.5287285-1.5287285-4.0402412 0-5.5689697 1.5287304-1.5287285 4.0402279-1.5287285 5.5689716 0l6.1149483 6.1149483 18.9999924-18.9999924c1.5287285-1.5287285 4.0402222-1.5287285 5.5689697 0 1.7471007 1.5287283 1.7471007 4.0402258.2183684 5.5689734z"
                                fill="#09b285"
                              ></path>
                            </svg>
                          </div>
                          <h3 className="text-center mb-4">
                            Phase 1 Completed
                          </h3>
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Example with label"
                            aria-valuemin={0}
                            aria-valuemax={100}
                          >
                            <div
                              className="progress-bar"
                              style={{ width: `100%` }}
                            />
                          </div>
                          <p className="d-flex align-items-center justify-content-between fs-small">
                            {" "}
                            <span>200,000 WIN</span>
                            <span>Total Token : 200K WIN</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item custom_acc_item phase_accordion">
                      <h2 className="accordion-header" id="consultQuestTwo">
                        <button
                          className="accordion-button acc_btn"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultCollapseTwo"
                          aria-expanded="false"
                          aria-controls="consultCollapseTwo"
                        >
                          <span>Phase 2</span>
                          <span>400,000 WIN</span>
                        </button>
                      </h2>
                      <div
                        id="consultCollapseTwo"
                        className="accordion-collapse collapse show"
                        aria-labelledby="consultQuestTwo"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body acc_body">
                          <h3 className="text-center mb-4">
                            Available Tokens : 375,000 WIN{" "}
                          </h3>
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Example with label"
                            aria-valuemin={0}
                            aria-valuemax={100}
                          >
                            <div
                              className="progress-bar"
                              style={{ width: `25%` }}
                            />
                          </div>
                          <p className="d-flex align-items-center justify-content-between fs-small">
                            {" "}
                            <span>25,000 WIN</span>
                            <span>Total Token : 400K WIN</span>
                          </p>
                          <div className="text-center">
                            <Button
                              className="primary_btn"
                              onClick={handleScrollToBuy}
                            >
                              Buy Token
                            </Button>
                          </div>

                          <div className="Buytoken_page_head mt-5">
                            <div>
                              <div className="sec_2 referral_page_sec_2 align-items-center">
                                <div>
                                  <p>My Investment (WIN)</p>
                                  <h6 class="mb-0">0 </h6>
                                </div>
                              </div>
                              <div className="sec_2 referral_page_sec_2 align-items-center">
                                <div>
                                  <p>Locked Amount (WIN)</p>
                                  <h6 class="mb-0">0 </h6>
                                </div>
                              </div>
                              <div className="sec_2 referral_page_sec_2 align-items-center">
                                <div>
                                  <p>My Rewards (WIN)</p>
                                  <h6 class="mb-0">0 </h6>
                                  <button
                                    className="claim_btn mt-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#claimModal"
                                  >
                                    Claim / Bid
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item custom_acc_item phase_accordion">
                      <h2 className="accordion-header" id="consultQuestThree">
                        <button
                          className="accordion-button acc_btn collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultCollapseThree"
                          disabled
                          aria-expanded="false"
                          aria-controls="consultCollapseThree"
                        >
                          <span>Phase 3</span>
                          <span>800,000 WIN</span>
                        </button>
                      </h2>
                      <div
                        id="consultCollapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="consultQuestThree"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body acc_body">
                          <h3 className="text-center mb-4">
                            Available Tokens : 800,000 WIN{" "}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item custom_acc_item phase_accordion">
                      <h2 className="accordion-header" id="consultQuestFour">
                        <button
                          className="accordion-button acc_btn collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultCollapseFour"
                          disabled
                          aria-expanded="false"
                          aria-controls="consultCollapseFour"
                        >
                          <span>Phase 4</span>
                          <span>1,600,000 WIN</span>
                        </button>
                      </h2>
                      <div
                        id="consultCollapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="consultQuestFour"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body acc_body">
                          <h3 className="text-center mb-4">
                            Available Tokens : 1,600,000 WIN{" "}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item custom_acc_item phase_accordion">
                      <h2 className="accordion-header" id="consultQuestFive">
                        <button
                          className="accordion-button acc_btn collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultCollapseFive"
                          disabled
                          aria-expanded="false"
                          aria-controls="consultCollapseFive"
                        >
                          <span>Phase 5</span>
                          <span>4,000,000 WIN</span>
                        </button>
                      </h2>
                      <div
                        id="consultCollapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="consultQuestFive"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body acc_body">
                          <h3 className="text-center mb-4">
                            Available Tokens : 4,000,000 WIN{" "}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="phase_section my-5">
                  <h2>Token Phase List</h2>
                  <div className="accordion" id="accordionExample2">
                    {!phaseslist || phaseslist.length === 0 ? (
                      <p className="text-center">No Phases Found</p>
                    ) : (
                      phaseslist.map((phase, idx) => {
                        const progress =
                          (phase.sold / phase.allocation) * 100 > 100
                            ? 100
                            : (phase.sold / phase.allocation) * 100;

                        // ✅ Determine which phase should be active:
                        // A phase is active if it's the first non-completed one.
                        const isCompleted = phase.completed;
                        const previousCompleted =
                          idx > 0 ? phaseslist[idx - 1]?.completed : true;
                        const isActive = !isCompleted && previousCompleted;

                        return (
                          <div
                            key={phase.id}
                            className="accordion-item custom_acc_item phase_accordion"
                          >
                            <h2
                              className="accordion-header"
                              id={`phase${phase.id}`}
                            >
                              <button
                                className={`accordion-button acc_btn ${!isActive ? "collapsed" : ""
                                  }`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${phase.id}`}
                                aria-expanded={isActive ? "true" : "false"}
                                aria-controls={`collapse${phase.id}`}
                                disabled={!isActive && !isCompleted}
                              >
                                <span>Phase {phase.id}</span>
                                <span>
                                  {phase.allocation.toLocaleString()} WIN
                                </span>
                              </button>
                            </h2>

                            <div
                              id={`collapse${phase.id}`}
                              className={`accordion-collapse collapse ${isActive ? "show" : ""
                                }`}
                              aria-labelledby={`phase${phase.id}`}
                              data-bs-parent="#accordionExample2"
                            >
                              <div className="accordion-body acc_body">
                                {isCompleted ? (
                                  <>
                                    <div className="text-center mb-4">✅</div>
                                    <h3 className="text-center mb-4">
                                      {phase.name} Completed
                                    </h3>
                                    <div className="progress">
                                      <div
                                        className="progress-bar"
                                        style={{ width: "100%" }}
                                      />
                                    </div>
                                    <p className="d-flex justify-content-between fs-small">
                                      <span>
                                        {phase.allocation.toLocaleString()} WIN
                                      </span>
                                      <span>
                                        Total Token :{" "}
                                        {phase.allocation.toLocaleString()} WIN
                                      </span>
                                    </p>
                                  </>
                                ) : isActive ? (
                                  <>
                                    <h3 className="text-center mb-4">
                                      Available Tokens :{" "}
                                      {(
                                        phase.allocation - phase.sold
                                      ).toLocaleString()}{" "}
                                      WIN
                                    </h3>
                                    <div className="progress">
                                      <div
                                        className="progress-bar"
                                        style={{ width: `${progress}%` }}
                                      />
                                    </div>
                                    <p className="d-flex justify-content-between fs-small">
                                      <span>
                                        {phase.sold.toLocaleString()} WIN
                                      </span>
                                      <span>
                                        Total Token :{" "}
                                        {phase.allocation.toLocaleString()} WIN
                                      </span>
                                    </p>
                                    <div className="text-center">
                                      <Button
                                        className="primary_btn"
                                        onClick={handleScrollToBuy}
                                      >
                                        Buy Token
                                      </Button>
                                    </div>

                                    <div className="Buytoken_page_head mt-5">
                                      <div>
                                        <div className="sec_2 referral_page_sec_2 align-items-center">
                                          <div>
                                            <p>My Investment (USDT)</p>
                                            <h6 class="mb-0">
                                              {investData?.myInvest
                                                ? formatNumber(
                                                  investData?.myInvest,
                                                  2
                                                )
                                                : 0}
                                            </h6>
                                          </div>
                                        </div>
                                        <div className="sec_2 referral_page_sec_2 align-items-center">
                                          <div>
                                            <p>My Rewards (WIN)</p>
                                            <h6 class="mb-0">
                                              {investData?.myReward
                                                ? formatNumber(
                                                  investData?.myReward,
                                                  2
                                                )
                                                : 0}{" "}
                                            </h6>
                                            <button
                                              className="claim_btn mt-2"
                                              data-bs-toggle="modal"
                                              data-bs-target="#claimModal"
                                              onClick={() => {
                                                setWithdrawPer("");
                                                setBucket("");
                                                setBucketValue("");
                                                setWithdrawDetails({
                                                  withdrawAmt: 0,
                                                  bidAmt: 0,
                                                  EquivalentAmt: 0,
                                                });
                                              }}
                                              disabled={
                                                !investData?.myReward ||
                                                investData?.myReward <= 0
                                              }
                                            >
                                              Claim / Bid
                                            </button>
                                          </div>
                                        </div>
                                        <div className="sec_2 referral_page_sec_2 align-items-center">
                                          <div>
                                            <p>Total Bid Amount (WIN)</p>
                                            <h6 class="mb-0">
                                              {investData?.totalBid
                                                ? formatNumber(
                                                  investData?.totalBid,
                                                  2
                                                )
                                                : 0}{" "}
                                            </h6>
                                          </div>
                                        </div>
                                        <div className="sec_2 referral_page_sec_2 align-items-center">
                                          <div>
                                            <p>My Claimed (USDT)</p>
                                            <h6 class="mb-0">
                                              {investData?.totalClaimed
                                                ? formatNumber(
                                                  investData?.totalClaimed,
                                                  2
                                                )
                                                : 0}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <h3 className="text-center mb-4">
                                    Upcoming Phase —{" "}
                                    {phase.allocation.toLocaleString()} WIN
                                  </h3>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>

                <div
                  id="buy-token-section"
                  ref={buyTokenSectionRef}
                  className="d-flex align-items-center justify-content-between mt-4"
                >
                  <p className="join_head mb-0"> Buy Token</p>
                  <div className="d-flex gap-2">
                    {/* {isConnected && (
                      <Button
                        className="primary_btn me-3"
                        onClick={() => claimReward()}
                        disabled={
                          staticTargetDate < new Date() &&
                            parseFloat(claimableamount) == 0
                            ? true
                            : false
                        }
                      >
                        Claim{" "}
                        {claimload && (
                          <i className="fas fa-spinner fa-spin"></i>
                        )}
                      </Button>
                    )} */}

                    {/* {isConnected ? (
                      <Link
                        to=""
                        className="primary_btn me-3"
                        onClick={disconnectWallet}
                      >
                        Disconnect
                      </Link>
                    ) : (
                      <Link
                        to=""
                        className="primary_btn me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Connect Wallet
                      </Link>
                    )} */}
                  </div>
                </div>
                <div className="Buytoken_input mt-4">
                  <div>
                    <div className="d-flex justify-content-between center_content">
                      <h6 className="timer_head">
                        {" "}
                        1 WIN Token = {activePhases?.pricePerWin} USDT
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="Buytoken_input mt-4">
                  <div>
                    <div className="d-flex justify-content-between">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Enter Amount (USDT): *
                      </Form.Label>
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Bal (USDT) :{" "}
                        {isConnected
                          ? formatNumber(balanceallowance?.balance, 6)
                          : 0}
                      </Form.Label>
                    </div>

                    <InputGroup className="input_group_box">
                      <Form.Control
                        placeholder="Enter a Round Amount"
                        aria-label="Referral Link"
                        aria-describedby="basic-addon1"
                        onChange={handlechange}
                        // onChange={(e) => {
                        //   const value = e.target.value
                        //   if (/^\d*$/.test(value)) {  // ✅ allows only digits (no decimals or letters)
                        //     handlechange(e)
                        //   }
                        // }}
                        value={sendreceive?.pay}
                        disabled={isload}
                      />
                    </InputGroup>

                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label
                          className="input_join"
                          htmlFor="inputReferral"
                        >
                          Referral ID: *
                        </Form.Label>
                        <span style={{ color: "#28a745", fontWeight: "500" }}>
                          10% USDT
                        </span>
                      </div>
                      <InputGroup className="input_group_box mt-1">
                        <Form.Control
                          id="inputReferral"
                          placeholder="Enter Referral ID"
                          aria-label="Referral Link"
                          aria-describedby="basic-addon1"
                          value={referralId || ""}
                          onChange={(e) => setReferralId(e.target.value)}
                          disabled={!!referralId}
                        />
                      </InputGroup>
                      {referror && (
                        <span style={{ color: "red" }}>{referror}</span>
                      )}
                    </div>

                    {/* <div className="d-flex justify-content-between">
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Bonus:
                      </Form.Label>
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        {bonus} WIN
                      </Form.Label>
                    </div> */}
                  </div>
                  <div>
                    <Form.Label className="input_join" htmlFor="inputPassword5">
                      You will get :
                    </Form.Label>
                    <InputGroup className="input_group_box">
                      <Form.Control
                        placeholder=""
                        aria-label="You will get"
                        aria-describedby="basic-addon1"
                        readOnly
                        value={sendreceive?.receive}
                      />
                    </InputGroup>
                  </div>
                  <div className="but_center mt-3">
                    {!address ? (
                      <Link
                        to=""
                        className="primary_btn me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Connect Wallet
                      </Link>
                    ) : showallowance ? (
                      <Link
                        to=""
                        className="nav_btn  mt-3"
                        onClick={() => approve()}
                      >
                        Approve{" "}
                        {loader && <i className="fas fa-spinner fa-spin"></i>}
                      </Link>
                    ) : (
                      <Link
                        to=""
                        className="nav_btn  mt-3"
                        onClick={() => buy()}
                      >
                        Buy{" "}
                        {loader && <i className="fas fa-spinner fa-spin"></i>}
                      </Link>
                    )}
                  </div>
                </div>
                {loader && (
                  <p className="text-center mt-3" style={{ color: "green" }}>
                    Please do not refresh the page while the payment is being
                    processed.
                  </p>
                )}
              </div>

              <BuyHistory
                setloadhistory={setloadhistory}
                loadhistory={loadhistory}
              />
            </Col>
          </Row>
        </Container>
      </section>

      <div
        class="modal fade model_box"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Connect Wallet
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className=" meta_connect">
                {connectors.map((connector, i) => {
                  if (
                    connector.name == "MetaMask" ||
                    connector.name == "WalletConnect"
                  ) {
                    return (
                      <div>
                        <img
                          src={
                            connector.name == "MetaMask"
                              ? require("../assets/images/meta_icon.png")
                              : require("../assets/images/wallet_icon.png")
                          }
                          alt="User"
                          className="img-fluid"
                          width={50}
                          height={50}
                          onClick={() => handleConnect(connector)}
                        />
                        <p className="mb-0">{connector.name}</p>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Claim Modal */}
      <div
        class="modal fade model_box"
        id="claimModal"
        tabindex="-1"
        aria-labelledby="claimModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="claimModalLabel">
                Claim
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="alert alert-warning" role="alert">
                <h5>Note:</h5>
                <p className="mb-0">
                  Withdraw up to a maximum of 10% of your rewards now. The
                  remaining 90% must be staked, and you can choose any of your
                  buckets.
                </p>
              </div>
              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <Form.Label className="input_join">
                    Withdraw Percentage:
                  </Form.Label>
                  <Form.Label className="input_join">Max: 10%</Form.Label>
                </div>
                <InputGroup className="input_group_box">
                  <Form.Control
                    placeholder="Enter Withdraw Percentage"
                    aria-label="Withdraw Percentage"
                    aria-describedby="basic-addon1"
                    value={withdrawPer}
                    onChange={handlechange1}
                  />
                </InputGroup>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <Form.Label className="input_join mb-0">
                  Withdraw Amount:
                </Form.Label>
                <Form.Label className="input_join mb-0 pink_txt fw-semibold">
                  {formatNumber(withdrawDetails?.withdrawAmt, 9)} WIN
                </Form.Label>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <Form.Label className="input_join mb-0">Bid Amount:</Form.Label>
                <Form.Label className="input_join mb-0 pink_txt fw-semibold">
                  {formatNumber(withdrawDetails?.bidAmt, 9)} WIN
                </Form.Label>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <Form.Label className="input_join mb-0">
                  Equivalent Amount:
                </Form.Label>
                <Form.Label className="input_join mb-0 pink_txt fw-semibold">
                  {formatNumber(withdrawDetails?.EquivalentAmt, 9)} USDT
                </Form.Label>
              </div>

              <div
                className="progress progress_bucket"
                role="progressbar"
                aria-label="Example with label"
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div className="progress-bar" style={{ width: `${progress}%` }} />
              </div>

              <div className="d-flex justify-content-between mb-2 align-items-center">
                <Form.Label className="input_join mb-0">
                  <img
                    src={require("../assets/images/bucket_1.png")}
                    alt=""
                    className="img-fluid me-2"
                    width={30}
                  />{" "}
                  Bucket 2{" "}
                  <span className="pink_txt fw-semibold">(${phaseslist?.[1]?.pricePerWin || 0})</span>:
                </Form.Label>
                <InputGroup className="input_group_box bucket_inp">
                  <Form.Control
                    aria-label="bucket 2"
                    aria-describedby="bucket 2"
                    value={bucketValues[2]}
                    onChange={(e) => handleBucketInput(e, 2)}
                  />
                </InputGroup>
              </div>

              <div className="d-flex justify-content-between mb-2 align-items-center">
                <Form.Label className="input_join mb-0">
                  <img
                    src={require("../assets/images/bucket_2.png")}
                    alt=""
                    className="img-fluid me-2"
                    width={30}
                  />{" "}
                  Bucket 3{" "}
                  <span className="pink_txt fw-semibold">(${phaseslist?.[2]?.pricePerWin || 0})</span>:
                </Form.Label>
                <InputGroup className="input_group_box bucket_inp">
                  <Form.Control
                    aria-label="bucket 3"
                    aria-describedby="bucket 3"
                    value={bucketValues[3]}
                    onChange={(e) => handleBucketInput(e, 3)}
                  />
                </InputGroup>
              </div>

              <div className="d-flex justify-content-between mb-2 align-items-center">
                <Form.Label className="input_join mb-0">
                  <img
                    src={require("../assets/images/bucket_3.png")}
                    alt=""
                    className="img-fluid me-2"
                    width={30}
                  />{" "}
                  Bucket 4{" "}
                  <span className="pink_txt fw-semibold">(${phaseslist?.[3]?.pricePerWin || 0})</span>:
                </Form.Label>
                <InputGroup className="input_group_box bucket_inp">
                  <Form.Control
                    aria-label="bucket 4"
                    aria-describedby="bucket 4"
                    value={bucketValues[4]}
                    onChange={(e) => handleBucketInput(e, 4)}
                  />
                </InputGroup>
              </div>

              <div className="d-flex justify-content-between mb-2 align-items-center">
                <Form.Label className="input_join mb-0">
                  <img
                    src={require("../assets/images/bucket_4.png")}
                    alt=""
                    className="img-fluid me-2"
                    width={30}
                  />{" "}
                  Bucket 5{" "}
                  <span className="pink_txt fw-semibold">(${phaseslist?.[4]?.pricePerWin || 0})</span>:
                </Form.Label>
                <InputGroup className="input_group_box bucket_inp">
                  <Form.Control
                    aria-label="bucket 5"
                    aria-describedby="bucket 5"
                    value={bucketValues[5]}
                    onChange={(e) => handleBucketInput(e, 5)}
                  />
                </InputGroup>
              </div>

              {/* <div className="mb-3">
                <Form.Label className="input_join" htmlFor="inputPassword5">
                  Choose Bucket:
                </Form.Label>
                <Form.Select
                  name="idType"
                  className="input_select"
                  id="bucket"
                  value={bucket}
                  onChange={handleBucketChange}
                >
                  <option value="">Select Bucket</option>
                  <option value="2">Phases/Bucket 2</option>
                  <option value="3">Phases/Bucket 3</option>
                  <option value="4">Phases/Bucket 4</option>
                  <option value="5">Phases/Bucket 5</option>
                </Form.Select>
              </div> */}

              {/* <div className="d-flex justify-content-between mb-2">
                <Form.Label className="input_join">Position Value:</Form.Label>
                <Form.Label className="input_join pink_txt fw-semibold">
                  {bucketValue} USDT
                </Form.Label>
              </div> */}

              <div className="text-center mt-4">
                <button
                  className="primary_btn"
                  onClick={ClaimReward}
                  disabled={claimload}
                >
                  Submit{" "}
                  {claimload && <i className="fas fa-spinner fa-spin"></i>}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
